import { useSubscription } from '@apollo/client';
import { useEffect, useState } from 'react';
export const useCustomSubscription = (subscription, options) => {
    const [delaySub, setDelaySub] = useState(true);
    useEffect(() => {
        let timeoutId = setTimeout(() => {
            setDelaySub(false);
            timeoutId = undefined;
        }, 1000);
        return () => timeoutId && clearTimeout(timeoutId);
    });
    return useSubscription(subscription, { ...options, skip: delaySub });
};
